module.exports = __webpack_public_path__ + "static/img/md5_black.a2d90d42.svg";